import { createApp } from 'vue';
import { API_URL } from '@/common/config';
import { getToken } from '@/common/jwt.service';
import VueProgressBar from '@aacassandra/vue3-progressbar';
import VueLazyload from '@jambonn/vue-lazyload';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import VueAxios from 'vue-axios';
import axios from 'axios';
import i18n from '@/i18n';
import { CHECK_AUTH } from '@/store/actions.type';
import { createHead } from '@vueuse/head';
import App from './App.vue';
import store from './store';
import router from './router';

const app = createApp(App);
app.use(VueAxios, axios);
app.use(router);
app.use(store);
const head = createHead();
app.use(head);
const loadimage = require('@/assets/images/loading/loading-spin.svg');
const errorimage = require('@/assets/images/loading/404.jpg');

app.use(VueLazyload, {
  observer: true, error: errorimage, loading: loadimage, attempt: 3,
});
app.use(i18n);
const options = {
  color: '#FFA459',
  failedColor: '#fd397a',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};
app.use(VueProgressBar, options);
app.use(VuePlyr);
app.mount('#app');

require('./assets/scss/bootstrap-grid.scss');
require('./assets/scss/bootstrap.scss');
require('./assets/scss/style.scss');
require('./assets/scss/override.scss');

app.config.productionTip = false;
app.axios.defaults.baseURL = API_URL;
app.axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);
router.beforeEach((to, from, next) => {
  store.dispatch(CHECK_AUTH)
    .then(() => {
      next();
    })
    .catch(() => {
      next();
    });
});
